export default __webpack_public_path__ + "static/media/deleteModalIcon.88140f25.svg";